import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { CartContext } from '../../contexts/CartContext';
import { RouterContext } from '../../contexts/RouterContext';
import { PAGES } from '../../Router/pages';

const removeIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/Apagar.svg';

import * as S from './styles';
import { ProductItemProps } from '../../models/Product';
import { Contact } from '../../models/AttendanceUnit';
import { PlatformContext } from '../../contexts/PlatformContext';
import { PRODUCT_CATEGORY_ICON } from '../../utils/constants/productCategoryIcon';

export type Unit = {
  active: boolean;
  address: string;
  address_complement: string;
  address_number: string;
  block_building: string;
  business_unit_work_hour_id: string;
  local_id?: string;
  business_unit_work_hour: {
    id: string;
    work_hour_start: string;
    work_hour_end: string;
    is_24h_weekdays: boolean;
    is_24h_weekends: boolean;
    is_24h_holiday: boolean;
    different_work_hour_start: string;
    different_work_hour_end: string;
    holiday_work_hour_start: string;
    holiday_work_hour_end: string;
    holiday: boolean;
    monday: boolean;
    tuesday: boolean;
    wednesday: boolean;
    thursday: boolean;
    friday: boolean;
    saturday: boolean;
    sunday: boolean;
  };
  cep: string;
  city: string;
  cnpj: string;
  id: string;
  id_sgh: string;
  img_url: string | null;
  name: string;
  neighborhood: string;
  phone?: string;
  phoneList?: Contact[]; // só existe para unidades da rota /branch do catálogo
  state: string;
  itemId?: string;
  catalogItemId?: string;
  isKit?: boolean;
  cnes?: string | number;
  latitude?: string;
  longitude?: string;
  locations?: {
    id: string;
    name: string;
    description: string;
    service_hours: null;
  }[];
  resources?: [
    {
      id: string;
      name: string;
      location_id: string;
    }
  ];
};

export type ButtonProps = {
  product: ProductItemProps;
  border?: boolean;
  disabled?: boolean;
  handleClick?: () => void;
  whitoutRemoveBtn?: boolean;
};

const ServiceItem = ({
  product,
  border = false,
  disabled = false,
  handleClick,
  whitoutRemoveBtn = false
}: ButtonProps) => {
  const { clearData } = useContextSelector(PlatformContext, state => state);
  const { productList, removeProductList } = useContextSelector(CartContext, state => state);
  const { resetSteps, goTo } = useContextSelector(RouterContext, state => state);

  const handleRemoveProduct = (productId: string) => {
    removeProductList(productId);
    goTo(PAGES.SERVICE_LIST.id);
    resetSteps();
    if (productList.length === 1) {
      clearData();
    }
  };

  let category = null;
  if (product.coverages?.length) category = PRODUCT_CATEGORY_ICON[product.coverages[0].category];

  return (
    <S.Container
      borderOrShadow={border}
      onClick={() => {
        if (handleClick) handleClick();
      }}
    >
      <S.HeadWrapper>
        {category && <img src={category.icon} alt={category.alt} />}
        <S.Column style={{ width: '100%' }}>
          <S.ProductName>{product.name}</S.ProductName>
          {category && <S.Price>{category.alt}</S.Price>}
        </S.Column>
        <S.Column>
          {!disabled && !whitoutRemoveBtn && (
            <button className="btn-remove" onClick={() => handleRemoveProduct(product?.idLocal || '')}>
              <img src={removeIcon} alt="remove" />
            </button>
          )}
        </S.Column>
        {/*  <S.Actions>

        </S.Actions> */}
      </S.HeadWrapper>
    </S.Container>
  );
};
export default ServiceItem;
